import React from 'react';
import { Route, Switch } from 'react-router';

import Sidebar from './javascript-sdk/Sidebar';
import Environment from './javascript-sdk/Environment';
import Reference from './javascript-sdk/Reference';
import Footer from './shared/Footer';
import ScrollToTop from './shared/ScrollToTop';
import HtmlPage from './javascript-sdk/HtmlPage';
import DropdownContainer from './javascript-sdk/containers/DropdownContainer';

// Presentational Component
const JavaScriptSdk = () => {
	return (
		<div className="page">
			<Sidebar />
			<main id="content" className="content with-sidebar">
				<div className="section">
					<div className='responsive-small'>
						<DropdownContainer />
					</div>
					<ScrollToTop scrollElId="content">
						<Switch>
							<Route exact path="/javascript-sdk" render={() => <HtmlPage page="Intro" />} ></Route>
							<Route exact path="/javascript-sdk/intro" render={() => <HtmlPage page="Intro" />} ></Route>
							<Route exact path="/javascript-sdk/environment" component={Environment} ></Route>
							<Route exact path="/javascript-sdk/promise" render={() => <HtmlPage page="Promise" />} ></Route>
							<Route exact path="/javascript-sdk/error" render={() => <HtmlPage page="Error" />} ></Route>
							<Route exact path="/javascript-sdk/auth" render={() => <HtmlPage page="Auth" />} ></Route>
							<Route exact path="/javascript-sdk/reference" component={Reference} ></Route>
						</Switch>
					</ScrollToTop>
				</div>
				<Footer />
			</main>
		</div>
	);
};

export default JavaScriptSdk;



// WEBPACK FOOTER //
// ./src/components/JavaScriptSdk.js